var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.6669 150.333V115.782H36.6667V139.333H60.2181V150.333H25.6669ZM115.852 150.333V139.333H139.404V115.782H150.404V150.333H115.852ZM25.6669 60.2179V25.6667H60.2181V36.6666H36.6667V60.2179H25.6669ZM139.404 60.2179V36.6666H115.852V25.6667H150.404V60.2179H139.404Z","fill":"black"}));
}

Expand.defaultProps = {"viewBox":"0 0 176 176","fill":"none"};

module.exports = Expand;

Expand.default = Expand;
